import React from 'react';
import PropTypes from 'prop-types';

const GalleryImage = ({ image, onClick }) => {
  return (
    <div className="square w-1/3 cursor-pointer md:w-1/12" onClick={onClick}>
      <div className="bg-cover bg-center gallery-item"
          style={{backgroundImage: `url("${image.thumbnail}")`}}>
      </div>
    </div>
  );
};

GalleryImage.propTypes = {
  image: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    photo: PropTypes.string.isRequired,
    thumbnail: PropTypes.string.isRequired,
    caption: PropTypes.string,
    number: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  onClick: PropTypes.func,
};

GalleryImage.defaultProps = {
  onClick: () => {},
};

export default GalleryImage;
